import { render, staticRenderFns } from "./31.vue?vue&type=template&id=6c22e4f2&scoped=true&"
import script from "./31.vue?vue&type=script&lang=js&"
export * from "./31.vue?vue&type=script&lang=js&"
import style0 from "./31.vue?vue&type=style&index=0&id=6c22e4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22e4f2",
  null
  
)

export default component.exports